/**
 * SRES · GlobalHotkeys (Iter112 · Feb 2026).
 *
 * Window-level keyboard listener that fires on ANY page, including
 * routes outside the wizard tree (marketing, auth, admin console).
 *
 * Bindings
 * --------
 *   ⌘/Ctrl + Shift + \\  →  toggle cinema mode (hide top nav +
 *                            sidebar). Complements the ⌘/Ctrl + \\
 *                            binding inside ProjectStageLayout that
 *                            collapses / expands the 9-step rail.
 */
import { useEffect } from "react";
import { toast } from "sonner";
import { getCinemaMode, setCinemaMode } from "@/lib/useCinemaMode";


export default function GlobalHotkeys() {
  useEffect(() => {
    const onKey = (e) => {
      const mod = e.metaKey || e.ctrlKey;
      if (!mod || !e.shiftKey) return;
      // Same input-guard rules as the ProjectStageLayout listener.
      const tag = (e.target?.tagName || "").toLowerCase();
      if (tag === "input" || tag === "textarea" || e.target?.isContentEditable) return;
      if (e.key === "\\" || e.code === "Backslash") {
        e.preventDefault();
        const next = !getCinemaMode();
        setCinemaMode(next);
        toast.success(
          next
            ? "Cinema mode on · top nav & sidebar hidden. ⌘/Ctrl+Shift+\\ to exit."
            : "Cinema mode off · UI restored.",
          { duration: 2200 },
        );
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return null;
}
